/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { ReservedSurveyMarkDto } from '../../models/reserved-survey-mark-dto';

export interface GetReservedSurveyMarksForUser$Params {
  sortByDate: boolean;
}

export function getReservedSurveyMarksForUser(
  http: HttpClient,
  rootUrl: string,
  params: GetReservedSurveyMarksForUser$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReservedSurveyMarkDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    getReservedSurveyMarksForUser.PATH,
    'get',
  );
  if (params) {
    rb.query('sortByDate', params.sortByDate, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservedSurveyMarkDto>;
      }),
    );
}

getReservedSurveyMarksForUser.PATH = '/me/surveyMarks/reserved';
